import React, { useState } from 'react';

import type { ReactNode } from 'react';

import { ArrowDown, ArrowUp } from '@travel/icons/ui';
import { useDeviceType } from '@travel/traveler-core/hooks';
import { IconTextList, TitleAccordion } from '@travel/ui';
import type { IconTextItem } from '@travel/ui/components/IconTextList';

import Invisible from '../../../../components/Invisible';

import styles from './basicInformation.module.scss';

export default function FacilityFeaturesBox(props: {
  id: string;
  title: string | ReactNode;
  items: Array<IconTextItem>;
}) {
  const isMobile = useDeviceType() === 'sp';
  const contents = (
    <IconTextList
      data-testid="facilityFeaturesBox-content"
      className={styles.iconTextList}
      iconTextClassName={styles.featureSize}
      iconTextSpacing={5}
      spaceBetween={0}
      items={props.items}
    />
  );

  // for SEO:
  // having the same state as TitleAccordion
  // to hide <Invisible/> when content is shown
  const [isOpen, setIsOpen] = useState(false);
  const handleAccordionClick = () => {
    setIsOpen(!isOpen);
  };

  return !isMobile ? (
    <div
      className={styles.featureBox}
      id={props.id}
      data-testid="providerInformation-basicInformation-facilityFeaturesBox"
    >
      <h4 className={styles.groupTitle}>{props.title}</h4>
      {contents}
    </div>
  ) : (
    <div>
      <TitleAccordion
        id={props.id}
        className={styles.featureBox}
        title={props.title}
        collapseIcon={<ArrowUp />}
        expandIcon={<ArrowDown />}
        onClick={handleAccordionClick}
        isOpen={isOpen}
        hasAnimation={true}
      >
        {contents}
      </TitleAccordion>
      {!isOpen && (
        <Invisible data-testid="providerInfo-facilityFeaturesBox-invisible">{contents}</Invisible>
      )}
    </div>
  );
}
